import React from 'react';

export const TRADEMARK_SYMBOL = <sup>&#8482;</sup>;
export const REGISTERED_SYMBOL = <sup>&#174;</sup>;

